export default __webpack_public_path__ + "static/AccountantDashboard-1d05f020058687da50dc0da36bc198ec.png";